module.exports = __webpack_public_path__ + "img/index2.09808e37.png";